module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.prev || _vm.next) ? _c('div', {
    staticClass: "navi",
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [(_vm.prev) ? _c('div', {
    staticClass: "navi__prev arrow"
  }, [_c('div', {
    staticClass: "arrow__icon arrow__icon_prev"
  }), _c('p', {
    staticClass: "arrow__text"
  }, [_vm._v(_vm._s(_vm.month))])]) : _vm._e(), (_vm.next) ? _c('div', {
    staticClass: "navi__next arrow"
  }, [_c('div', {
    staticClass: "arrow__icon arrow__icon_next"
  }), _c('p', {
    staticClass: "arrow__text"
  }, [_vm._v(_vm._s(_vm.month))])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d6c5cff","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/navi/Navi.vue
// module id = ef5034bee89acd47e0e1
// module chunks = 7